import { useContext, useRef } from "react";
import { Grid } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import styles from "./styles.module.css";
import ShopContext from "../../../context/ShopContext";
import ButtonRed from "../../utils/CustomFields/ButtonRed";
import ButtonGray from "../../utils/CustomFields/ButtonGray";
import { roundOff } from "helpers/NumberFormatHelper";
import * as TerminalHelper from "helpers/TermialHelper";
import DateTimeHelpers from "helpers/DateTimeHelpers";
import { generateUpiUrl } from "helpers/UpiHelper";

function GeneratePaymentQrDialog({ onClose, onSaveAndClose, sale, shop, amount: overrideAmount }) {
  const { selectedShop } = useContext(ShopContext);
  const qrRef = useRef();

  const handleReceivedClick = async () => {
    if (onSaveAndClose) onSaveAndClose();
  };

  const shopInfo = selectedShop || shop;
  const terminalSettings = TerminalHelper.getTerminalSettings();
  const upiId = terminalSettings?.upi_id;

  let qrValue = "";

  if (upiId) {
    const name = shopInfo?.shop_name;
    const amount = roundOff(overrideAmount !== undefined ? overrideAmount : sale?.payable);
    const note = `Invoice ${sale?.bill_no || ""}`;
    qrValue = generateUpiUrl({ upiId, name, amount, note });
  } else {
    const paymentData = {
      shop_name: shopInfo?.shop_name,
      shop_phone: shopInfo?.mobile_no || "",
      bill_no: sale?.bill_no,
      amount: roundOff(overrideAmount !== undefined ? overrideAmount : sale?.payable),
      date: DateTimeHelpers.formatDateAndTime(DateTimeHelpers.getLocalISOString()),
    };
    qrValue = JSON.stringify(paymentData);
  }

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.inputSec}>
          <div className={styles.headSec}>
            {shopInfo?.shop_logo ? (
              <img src={shopInfo.shop_logo} alt="Shop Logo" className={styles.logo} />
            ) : (
              <span className={styles.logoHead}>{shopInfo?.shop_name}</span>
            )}
          </div>
          <Grid container justifyContent="center">
            <h3 className={styles.subTitle}>Scan with any UPI app</h3>
            <Grid item container xs={12} className={styles.qrContainer} ref={qrRef}>
              <Grid item xs={12} display="flex" justifyContent="center">
                <QRCodeCanvas value={qrValue} size={230} level="H" />
              </Grid>

              {upiId && (
                <Grid item xs={12} pt={1}>
                  <span className={styles.textSub}>{upiId}</span>
                </Grid>
              )}

              <Grid item xs={12} pt={1}>
                <span className={styles.textSub}>Powered by Sanoft</span>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <div className={styles.footSec}>
          <ButtonGray fullWidth onClick={onClose}>
            Cancel
          </ButtonGray>
          <ButtonRed fullWidth onClick={handleReceivedClick}>
            Received
          </ButtonRed>
        </div>
      </div>
    </div>
  );
}

export default GeneratePaymentQrDialog;
